import AdminDeleteButton from '../../common/AdminDeleteButton';
import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';
import moment from 'moment';

const ShipList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { ships, total, page } = data;

    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Vessel Information</th>
                            <th>Owner Details</th>
                            <th>Other Details</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ships?.length > 0 ? (
                            ships.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span
                                                className="avatar-title rounded-circle bg-light text-primary"
                                                title={`Ship ID: ${item.ID}`}
                                            >
                                                {item.ID || 'NA'}
                                            </span>
                                        </div>
                                    </td>
                                    <td>
                                        <h5 className="font-size-14 mb-1">
                                            <a href="javascript:void(0)" className="text-dark">
                                                {item.SHIP_NAME} - {item.SHIP_CODE}
                                            </a>
                                        </h5>
                                        <p className="text-muted mb-0">
                                            HN : <span style={{ color: "#ab5858 " }}>{item.HULL_NUMBER}</span>
                                        </p>
                                        <p className="text-muted mb-0">
                                            Project : <span style={{ color: "#2b5a7e" }}>{item.PROJECT_NAME || '-'}</span>
                                        </p>
                                        <p className="text-muted mb-0">
                                            <span style={{ color: "#f46a6a" }}>Last Updated</span> | {moment(item.MODIFIED_ON).format('DD MMM, YYYY')}{" "}
                                        </p>
                                    </td>
                                    <td>
                                        <h5 className="font-size-14 mb-1">
                                            <a href="javascript:void(0);" className="text-dark">
                                                {item.SHIP_OWNER_NAME}
                                            </a>
                                        </h5>
                                        <p className="text-muted mb-0">
                                            <a href="javascript:void(0);" className="text-dark">
                                                <span style={{ color: "#2b5a7e" }}>
                                                    {item.SHIP_OWNER_ADDRESS}
                                                </span>
                                            </a>
                                        </p>
                                    </td>
                                    <td style={{ padding: '12px', verticalAlign: 'top' }}>

                                        <p className="text-muted mb-0">
                                            IMO Number :{" "}
                                            <span >{item.IMO_NUMBER || '-'}</span>
                                        </p>
                                        <p className="text-muted mb-0">
                                            Official Number :{" "}
                                            <span >{item.SHIP_CODE || '-'}</span>
                                        </p>
                                        <p className="text-muted mb-0">
                                            Call Sign :{" "}
                                            <span >{item.CLASS_NUMBER || '-'}</span>
                                        </p>

                                    </td>

                                    <td>
                                        <span
                                            className={`badge rounded-pill ${item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'
                                                }`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item px-2">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editShipMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page: page,
                                                        },
                                                    }}
                                                    title="Edit"
                                                >
                                                    <i className="bx bx-edit"></i>
                                                </Link>
                                            </li>
                                            <li className="list-inline-item px-2">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => onChangeVisibility(item)}
                                                    title="Change Status"
                                                    style={{ color: "red" }}
                                                    className="text-danger"
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </a>
                                            </li>
                                        <li className="list-inline-item px-2"><AdminDeleteButton resource="ship" entryId={item.ID} label="ship" /></li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="11" className="text-center">
                                    No Ships found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default withRouter(ShipList);
